// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-field[data-v-79f8591c] {\n  color: var(--magic-text-dark, #1d2939);\n  --magic-field-border: var(--magic-text-medium, #5d6679);\n}\n\n.button[data-v-79f8591c] {\n  top: calc(var(--magic-space, 16px) - var(--magic-space--xx-small, 2px));\n  right: var(--magic-space, 16px);\n}\n\n.icon--remove[data-v-79f8591c] {\n  width: calc(var(--magic-icon-size, 20px) - var(--magic-space--small, 8px));\n  height: calc(var(--magic-icon-size, 20px) - var(--magic-space--small, 8px));\n}", ""]);
// Exports
module.exports = exports;
